export enum ActStatus {
  FORMED = 1,
  SIGNED = 2,
  PAID = 3,
}
